import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "~/components/ui/dialog";

import { modalStore } from "@/lib/stores/modals";
import { m } from "@/paraglide/messages";
import { useStore } from "@tanstack/react-store";
import InviteCard from "./index";

export default function InviteModal() {
	const { inviteModalOpen } = useStore(modalStore);
	return (
		<div>
			<Dialog
				open={inviteModalOpen}
				onOpenChange={(open) => modalStore.setInviteModalOpen(open)}
			>
				<DialogContent className="!w-full md:!max-w-[484px] md:max-h-[663px]">
					<DialogHeader>
						<DialogTitle>{m.invite()}</DialogTitle>
					</DialogHeader>
					<div className="overflow-auto max-h-[80vh] pr-4 md:pr-6">
						<InviteCard />
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}
